module.exports = __webpack_public_path__ + "static/img/oddnary-pink-scheme.66334700.jpg";